import * as React from 'react';

interface ModalContextType {
	openModal: (modalType: string) => void;
}

export const ModalContext = React.createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
	const context = React.useContext(ModalContext);
	if (!context) {
		throw new Error('useModal must be used within a ModalProvider');
	}
	return context;
};
